import React, { useEffect, useState } from 'react'
import {
  Dropdown,
  Responsive
} from 'semantic-ui-react'
// Local
import { API_URL } from '../../constant'
import { api } from '../../action/api'

/**
 * Provides a stand-alone appointment type select widget
 * @param onChange Callback function on appointment type select
 *   Arguments: (e, {name, value}) where value is the appointment type name or
 *   "" if the ALL option is selected
 * @param name Name of the select widget in a form context. Default:
 *   appointmentTypeSelect
 * @param value Initial selected appointment type
 * @param placeholder Placeholder text. Default: Appointment Types
 * @param multiple Allow multiple selections. Default: true
 * @param allOption If true, include an 'ALL' option. Default: true
 */

type NameAndValue = {
  name: string
  value: string[] | null
}

type Props = {
  name: string
  onChange: (
    e: any,
    nameAndValue: NameAndValue
  ) => void
  value: string[]
  placeholder: string
  multiple: boolean
  allOption: boolean
}

function AppointmentTypeSelect(
  props: Props
): JSX.Element {
  const {
    name: nameProp,
    onChange: onChangeProp,
    value: valueProp,
    placeholder: placeholderProp,
    multiple: hasMultipleProp,
    allOption: hasAllOptionProp
  } = props
  const [
    appointmentTypesState,
    setAppointmentTypesState
  ] = useState<any[]>([])

  const hasMultipleState = hasMultipleProp !== false
  const hasAllOptionState = hasAllOptionProp !== false

  useEffect(() => {
    let mounted = true
    api.get(API_URL.GET_APPOINTMENT_TYPES).then(({ data }) => {
      if (!mounted) return
      setAppointmentTypesState(data as any[])
    })
    return () => { mounted = false }
  }, [])

  const onChange = (
    e: any,
    { value }: NameAndValue
  ): void => {
    if (!onChangeProp) return
    if (Array.isArray(value) && value.includes('ALL')) {
      onChangeProp(e, {
        name: nameProp || 'appointmentTypeSelect',
        value: []
      })
      return
    }

    onChangeProp(e, (() => {
      return {
        name: nameProp || 'appointmentTypeSelect',
        value: Array.isArray(value) ? value : value ? [value] : null
      };
    })());

  }

  const options = appointmentTypesState.map(aptType => ({
    key: aptType,
    value: aptType,
    text: aptType
  }))
  if (hasAllOptionState === true) {
    options.unshift({
      key: 'ALL',
      text: 'ALL',
      value: 'ALL'
    })
  }
  const placeholder = placeholderProp || 'Appointment Types'
  if (hasMultipleState === true) {
    const value = Array.isArray(valueProp)
    ? valueProp
    : valueProp
      ? [valueProp]
      : []
    return (
      <Responsive
        as={ Dropdown }
        fluid multiple selection
        placeholder={ placeholder }
        onChange={ onChange }
        options={ options }
        value={ value }
      />
    )
  }
  return (
    <Responsive
      as={ Dropdown }
      fluid selection
      placeholder={ placeholder }
      onChange={ onChange }
      options={ options }
      value={ valueProp || undefined }
    />
  )

}

export default AppointmentTypeSelect
